import React from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { BTN_DARK_THEME, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON, Button, } from '@yme/atoms/button';
import { DisclaimerText } from '@yme/atoms/disclaimer-text';
import { Col, Container, Row } from '@yme/atoms/grid';
import { ShowMore } from '@yme/atoms/show-more';
import { useIsMount } from '@yme/hooks/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export function ContentMobileView(props) {
    const { 
    // Provided from AEM
    description, disclaimer, 
    // Extra props
    isRightToLeft, onClickHandler, learnMoreLabel, showLessLabel, showMoreLabel, brandedColor, } = props;
    const isMount = useIsMount();
    const isContentForMobileExist = [description, learnMoreLabel, disclaimer].every((item) => Boolean(item));
    if (!isContentForMobileExist) {
        return null;
    }
    return (React.createElement(Container, { bgColor: brandedColor, pt: "24px", pb: "24px" },
        description && !isMount && (React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(ShowMore, { maxLinesCount: 3, labelShowLess: showLessLabel, labelShowMore: showMoreLabel, bottomIndent: "0", wrapper: RegularTextLevel3, textColor: colorCoreWhite1000, buttonColor: colorCoreWhite1000 }, description)))),
        learnMoreLabel && (React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(FlexWrapper, { mt: "24px" },
                    React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, iconRotate: 90, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, isRightToLeft: isRightToLeft, label: learnMoreLabel, colorSchema: BTN_DARK_THEME, onClick: onClickHandler }))))),
        disclaimer && (React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(FlexWrapper, { mt: "24px" },
                    React.createElement(DisclaimerText, { disclaimerText: disclaimer })))))));
}
ContentMobileView.displayName = 'ContentMobileView_Component';
